<template>
  <div>
    <!-- 活动标题 -->
    <div v-wechat-title="'诺米的日记 -《使魔计划》'"></div>
    <!-- 首页进入青瓷游戏LOGO -->
    <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut' name='fade'>
      <div @touchmove.prevent class='preloading preloading-smjh' v-show='preloadingShow'></div>
    </transition>

    <Header
      v-if='true'
      :config='headerConfig'
      :isShowInfo='false' />

      <div class="home-page-help">
        <div class="diary-content">
          <div class="diary-title" title="日记封面页面"></div>
          <div class="open-btn"></div>
          <div class="help-btn" @click="onHelp()"></div>
          <div class="diary-bg"></div>
        </div>

      </div>
      <!-- 助力成功 -->
      <div class="help_wrap popup_wrap" v-show="helpSuccessShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
          <div class="help_success_box popup_wrap_box" v-show="helpSuccessShow">
            <div class="download_btn" @click="onDownload()"></div>
            <div class="active_btn" @click="onActive()"></div>
            <div class="close_btn" @click="closePopup('helpSuccessShow')"></div> 
          </div>
        </transition>
        <div class="close-bg" v-show="helpSuccessShow" @click="closePopup('helpSuccessShow')"></div>
      </div>
      <!-- 已助力过 -->
      <div class="help_wrap popup_wrap" v-show="helpSuccessShow2">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
          <div class="help_success_box2 popup_wrap_box" v-show="helpSuccessShow2">
            <div class="download_btn" @click="onDownload()"></div>
            <div class="active_btn" @click="onActive()"></div>
            <div class="close_btn" @click="closePopup('helpSuccessShow2')"></div> 
          </div>
        </transition>
        <div class="close-bg" v-show="helpSuccessShow2" @click="closePopup('helpSuccessShow2')"></div>
      </div>
      <!-- 助力失败 已助力 -->
      <div class="help_wrap popup_wrap" v-show="helpedFailShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
          <div class="helped_box popup_wrap_box" v-show="helpedFailShow">
            <div class="download_btn" @click="onDownload()"></div>
            <div class="active_btn" @click="onActive()"></div>
            <div class="close_btn" @click="closePopup('helpedFailShow')"></div> 
          </div>
        </transition>
        <div class="close-bg" v-show="helpedFailShow" @click="closePopup('helpedFailShow')"></div>
      </div>
      <!-- 助力失败 不能自己助力自己 -->
      <div class="help_wrap popup_wrap" v-show="helpSelfFailShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
          <div class="help_self_box popup_wrap_box" v-show="helpSelfFailShow">
            <div class="download_btn" @click="onDownload()"></div>
            <div class="active_btn" @click="onActive()"></div>
            <div class="close_btn" @click="closePopup('helpSelfFailShow')"></div> 
          </div>
        </transition>
        <div class="close-bg" v-show="helpSelfFailShow" @click="closePopup('helpSelfFailShow')"></div>
      </div>
      <!-- 助力失败 助力上限 -->
      <div class="help_wrap popup_wrap" v-show="helpMaxFailShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
          <div class="help_max_box popup_wrap_box" v-show="helpMaxFailShow">
            <div class="download_btn" @click="onDownload()"></div>
            <div class="active_btn" @click="onActive()"></div>
            <div class="close_btn" @click="closePopup('helpMaxFailShow')"></div> 
          </div>
        </transition>
        <div class="close-bg" v-show="helpMaxFailShow" @click="closePopup('helpMaxFailShow')"></div>
      </div>
  </div>

</template>
<script>
import { Toast } from 'mint-ui';
import { mapState, mapMutations, mapActions } from 'vuex';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { headerConfig } from '../headerConfig';
import { onHelpGetInitDataAPI, onGetInitDataAPI, onHelpAPI } from '../api';
import { getRandomString, buriedLogger, analysisParams } from '@/utils/utils';
export default {
  name: 'nmrj',
  components: {
    Header,
    Footer
  },
  data () {
    return {
      headerConfig,
      gameName: 'servitor',
      preloadingShow: true,
      titleShow: true,
      logger: null,

      helpSuccessShow: false,
      helpSuccessShow2: false,
      helpedFailShow: false,
      helpSelfFailShow: false,
      helpMaxFailShow: false,

      activeUrl: null,
      friendId: null
    };
  },
  created () {
    const { protocol, host } = window.location;
    const params = analysisParams(window.location.href);
    this.friendId = params.id;
    this.activeUrl = `${protocol}//${host}/servitor/nmrj/enter${getRandomString()}`;

    onHelpGetInitDataAPI({friend_id: params.id}).then(response => {
      this.onInitDataCallback(response, {needAccount: false, needUpdateInfo: false, name});
      this.preloadingShow = false;
    });

    // 埋点
    const bl = buriedLogger('servitor', '使魔3月份H5活动_助力页');
    this.logger = bl;
    setTimeout(() => {
      this.setShare({
        title: '诺米的日记 -《使魔计划》',
        desc: '求助力~帮我重温诺米的回忆吧！点击助力《使魔计划》活动',
        imgUrl: 'https://download4.qcplay.com/qcgame-admin/f4662HDaVOq8pLVvcJPHgSVdVkrnpv8mJmCWaQz4.jpg'
      });
    }, 2000);
  },
  computed: {
    ...mapState([])
  },
  methods: {
    openPopup (name) {
      this[name] = true;
      const map = {
        detailShow: '活动详情',
        rewardShow: '奖励礼包'
      };
      if (map[name]) {
        this.logger.sum(`使魔3月份H5活动_${map[name]}`);
      }
    },
    closePopup (name) {
      this[name] = false;
    },
    goJoinGroup () {
      window.location.href = 'https://static2.qcplay.com/qq_group_jump/index.html?game_id=33';
    },
    onDownload () {
      window.location.href = 'https://smjh.qingcigame.com/leading/';
    },
    onActive () {
      window.location.href = this.activeUrl;
    },
    onHelp () {
      if (!this.friendId) {
        this.onToast('无效助力链接！');
        return false;
      }
      onHelpAPI({ friend_id: this.friendId })
        .then(response => {
          const { code, message } = response;
          switch (code) {
            case 200:
              this.openPopup('helpSuccessShow');
              break;
            case 404: // 不能助力自己
              this.openPopup('helpSelfFailShow');
              break;
            case 403:
              this.openPopup('helpSuccessShow2');
              break;
            case 406: // 助力上限
              this.openPopup('helpMaxFailShow');
              break;
            case 407: // 已助力
              this.openPopup('helpedFailShow');
              break;
            default:
              this.onToast(message);
          }
        });
      this.logger.sum('使魔3月份H5活动_好友助力');
    },
    // TAG: 其他简易封装的方法
    onToast (config) {
      const curConfig = {
        duration: 1000,
        className: 'toasts'
      };
      if (!config) {
        console.error('缺少config参数');
        return false;
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    ...mapMutations([]),
    ...mapActions(['onInitDataCallback', 'setShare'])
  }
};
</script>

<style lang="less">
  @import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/servitor/nmrj/help/index.vue